export default __webpack_public_path__ + "static/media/Plus.a129a949.svg";